import { useState, useEffect } from 'react';
import { getRoletaConfig, salvarRoletaConfig, atualizarPremio } from '../../services/api';
import axios from 'axios';

const TIPOS = [
  { value: 'desconto_pct',   label: '% Desconto' },
  { value: 'desconto_valor', label: 'R$ Desconto' },
  { value: 'produto_gratis', label: 'Produto Grátis' },
  { value: 'pontos_bonus',   label: 'Pontos Bônus' },
  { value: 'sem_premio',     label: 'Tente Novamente' },
];
const CORES = ['#e63030','#ff6b00','#cc2020','#ff8c00','#2ea82e','#4a9eff','#9b59b6','#444444'];
const defaultPremio = { nome:'', descricao:'', tipo:'desconto_pct', valor:0, pontos_bonus:0, cor:'#e63030', probabilidade:10, ativo:1 };

const api = (url, opts={}) => axios({ url, ...opts, headers: { ...opts.headers, Authorization: `Bearer ${localStorage.getItem('token')}` } });

// ✅ FORA do componente principal — evita re-criação a cada render
const FormPremio = ({ dados, onChange, onSalvar, onCancelar, labelBtn = '✅ Salvar', loading }) => (
  <div style={{ background:'var(--bg4)', border:'1px solid var(--orange)', borderRadius:10, padding:16, marginTop:8 }}>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
      <div className="input-group" style={{ marginBottom:0 }}>
        <label className="input-label">Nome *</label>
        <input className="input-field" placeholder="Ex: 10% OFF" value={dados.nome} onChange={e => onChange('nome', e.target.value)} />
      </div>
      <div className="input-group" style={{ marginBottom:0 }}>
        <label className="input-label">Tipo</label>
        <select className="input-field" value={dados.tipo} onChange={e => onChange('tipo', e.target.value)} style={{ cursor:'pointer' }}>
          {TIPOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>
    </div>
    <div className="input-group">
      <label className="input-label">Descrição</label>
      <input className="input-field" placeholder="Ex: Desconto no próximo pedido" value={dados.descricao} onChange={e => onChange('descricao', e.target.value)} />
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
      {dados.tipo !== 'sem_premio' && dados.tipo !== 'pontos_bonus' && (
        <div className="input-group" style={{ marginBottom:0 }}>
          <label className="input-label">{dados.tipo === 'desconto_pct' ? 'Valor (%)' : 'Valor (R$)'}</label>
          <input className="input-field" type="number" step="0.01" value={dados.valor} onChange={e => onChange('valor', e.target.value)} />
        </div>
      )}
      {dados.tipo === 'pontos_bonus' && (
        <div className="input-group" style={{ marginBottom:0 }}>
          <label className="input-label">Pontos bônus</label>
          <input className="input-field" type="number" value={dados.pontos_bonus} onChange={e => onChange('pontos_bonus', e.target.value)} />
        </div>
      )}
      <div className="input-group" style={{ marginBottom:0 }}>
        <label className="input-label">Probabilidade (%)</label>
        <input className="input-field" type="number" min="1" max="100" value={dados.probabilidade} onChange={e => onChange('probabilidade', e.target.value)} />
      </div>
    </div>
    <div className="input-group">
      <label className="input-label">Cor</label>
      <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
        {CORES.map(cor => (
          <div key={cor} onClick={() => onChange('cor', cor)} style={{ width:26, height:26, borderRadius:'50%', background:cor, cursor:'pointer', border: dados.cor === cor ? '3px solid #fff' : '2px solid transparent', boxShadow: dados.cor === cor ? `0 0 0 2px ${cor}` : 'none' }} />
        ))}
        <input type="color" value={dados.cor} onChange={e => onChange('cor', e.target.value)} style={{ width:36, height:28, borderRadius:6, border:'1px solid var(--border)', background:'none', cursor:'pointer', padding:2 }} />
      </div>
    </div>
    <div style={{ display:'flex', gap:8, marginTop:4 }}>
      <button className="btn-primary" onClick={onSalvar} disabled={loading} style={{ flex:1 }}>{labelBtn}</button>
      <button className="btn-secondary" onClick={onCancelar} style={{ width:'auto', padding:'12px 16px' }}>Cancelar</button>
    </div>
  </div>
);

export default function AdminRoleta() {
  const [aba, setAba] = useState('premios');
  const [config, setConfig] = useState({ ativo:1, titulo:'Rodada da Sorte!', subtitulo:'' });
  const [premios, setPremios] = useState([]);
  const [editando, setEditando] = useState(null);
  const [adicionando, setAdicionando] = useState(false);
  const [novoForm, setNovoForm] = useState(defaultPremio);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState('');

  const [cupons, setCupons] = useState([]);
  const [loadingCupons, setLoadingCupons] = useState(false);
  const [busca, setBusca] = useState('');
  const [filtroCupom, setFiltroCupom] = useState('todos');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };
  const totalProb = premios.reduce((a, p) => a + parseFloat(p.probabilidade || 0), 0);

  useEffect(() => {
    getRoletaConfig().then(r => { setConfig(r.data.config || {}); setPremios(r.data.premios || []); }).catch(() => {});
  }, []);

  useEffect(() => {
    if (aba === 'cupons') carregarCupons();
  }, [aba]);

  const carregarCupons = async () => {
    setLoadingCupons(true);
    try {
      const r = await api('/api/roleta/cupons-historico');
      setCupons(r.data);
    } catch { showToast('❌ Erro ao carregar cupons'); }
    finally { setLoadingCupons(false); }
  };

  const salvarConfig = async () => {
    setLoading(true);
    try { await salvarRoletaConfig(config); showToast('✅ Configuração salva!'); }
    catch { showToast('❌ Erro ao salvar'); }
    finally { setLoading(false); }
  };

  const salvarPremio = async (p) => {
    try { await atualizarPremio(p.id, p); showToast('✅ Prêmio atualizado!'); setEditando(null); }
    catch { showToast('❌ Erro ao atualizar'); }
  };

  const adicionarPremio = async () => {
    if (!novoForm.nome) return showToast('⚠️ Informe o nome');
    setLoading(true);
    try {
      await api('/api/roleta/premios', { method: 'POST', data: novoForm });
      showToast('✅ Prêmio adicionado!');
      setNovoForm(defaultPremio);
      setAdicionando(false);
      const r = await getRoletaConfig();
      setPremios(r.data.premios || []);
    } catch { showToast('❌ Erro ao adicionar'); }
    finally { setLoading(false); }
  };

  const removerPremio = async (id) => {
    if (!window.confirm('Remover este prêmio?')) return;
    try {
      await api(`/api/roleta/premios/${id}`, { method: 'DELETE' });
      showToast('🗑️ Removido');
      setPremios(prev => prev.filter(p => p.id !== id));
    } catch { showToast('❌ Erro ao remover'); }
  };

  const toggleAtivo = async (p) => {
    const updated = { ...p, ativo: p.ativo == 1 ? 0 : 1 };
    setPremios(prev => prev.map(x => x.id === p.id ? updated : x));
    await atualizarPremio(p.id, updated);
  };

  const updatePremio = (id, field, value) =>
    setPremios(prev => prev.map(p => p.id === id ? { ...p, [field]: value } : p));

  const cuponsFiltrados = cupons.filter(c => {
    const matchBusca = !busca || c.cliente_nome?.toLowerCase().includes(busca.toLowerCase()) || c.cupom_codigo?.toLowerCase().includes(busca.toLowerCase());
    const matchFiltro = filtroCupom === 'todos' ? true : filtroCupom === 'usado' ? c.usado : !c.usado;
    return matchBusca && matchFiltro;
  });

  return (
    <div style={{ padding:24 }}>
      {toast && <div style={{ position:'fixed', top:70, left:'50%', transform:'translateX(-50%)', background:'linear-gradient(90deg,var(--red),var(--orange))', color:'#fff', padding:'10px 20px', borderRadius:20, fontSize:13, fontWeight:700, zIndex:999, whiteSpace:'nowrap' }}>{toast}</div>}

      <h2 style={{ marginBottom:4 }}>🎰 Controle da Roleta</h2>

      <div style={{ display:'flex', gap:4, background:'var(--bg3)', padding:4, borderRadius:8, marginBottom:20 }}>
        {[['premios','🎁 Prêmios'],['cupons','🎟️ Cupons gerados']].map(([key,label]) => (
          <button key={key} onClick={() => setAba(key)} style={{
            flex:1, background: aba===key ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'none',
            border:'none', color: aba===key ? '#fff' : 'var(--text2)',
            padding:9, borderRadius:6, cursor:'pointer', fontFamily:'Nunito,sans-serif', fontWeight:700, fontSize:13
          }}>{label}</button>
        ))}
      </div>

      {aba === 'premios' && (
        <>
          <div className="card" style={{ marginBottom:20 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
              <div>
                <h3>⚙️ Configuração Geral</h3>
                <p style={{ fontSize:12, color:'var(--text2)', marginTop:2 }}>Ativar ou desativar a roleta para todos os pedidos</p>
              </div>
              <label style={{ position:'relative', width:56, height:30, cursor:'pointer', flexShrink:0 }}>
                <input type="checkbox" checked={config.ativo==1} onChange={e => setConfig(p => ({ ...p, ativo: e.target.checked?1:0 }))} style={{ opacity:0, width:0, height:0 }} />
                <span style={{ position:'absolute', inset:0, background: config.ativo==1?'var(--orange)':'var(--bg4)', border:`1px solid ${config.ativo==1?'var(--orange)':'var(--border)'}`, borderRadius:15, transition:'.2s' }}>
                  <span style={{ position:'absolute', width:24, height:24, background:'#fff', borderRadius:'50%', top:2, left: config.ativo==1?28:2, transition:'.2s' }} />
                </span>
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:12 }}>
              <div className="input-group" style={{ marginBottom:0 }}>
                <label className="input-label">Título</label>
                <input className="input-field" value={config.titulo||''} onChange={e => setConfig(p => ({ ...p, titulo: e.target.value }))} />
              </div>
              <div className="input-group" style={{ marginBottom:0 }}>
                <label className="input-label">Subtítulo</label>
                <input className="input-field" value={config.subtitulo||''} onChange={e => setConfig(p => ({ ...p, subtitulo: e.target.value }))} />
              </div>
            </div>
            <button className="btn-primary" onClick={salvarConfig} disabled={loading} style={{ width:'auto', padding:'10px 24px' }}>
              {loading ? '⏳...' : '💾 Salvar'}
            </button>
          </div>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
            <div>
              <h3>🎁 Prêmios</h3>
              <p style={{ fontSize:12, color: totalProb>100?'var(--red)':totalProb===100?'#2ea82e':'var(--orange)', marginTop:2 }}>
                Total: {totalProb.toFixed(0)}% {totalProb>100?'⚠️ Acima de 100%!':totalProb===100?'✅':' (ideal: 100%)'}
              </p>
            </div>
            <button onClick={() => { setAdicionando(true); setNovoForm(defaultPremio); }} style={{ background:'linear-gradient(90deg,var(--red),var(--orange))', border:'none', color:'#fff', padding:'10px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:800 }}>+ Novo prêmio</button>
          </div>

          {adicionando && (
            <div className="card" style={{ marginBottom:16, border:'1px solid var(--orange)' }}>
              <h3 style={{ color:'var(--orange)', marginBottom:0 }}>➕ Novo prêmio</h3>
              <FormPremio
                dados={novoForm}
                onChange={(f,v) => setNovoForm(p => ({ ...p, [f]:v }))}
                onSalvar={adicionarPremio}
                onCancelar={() => setAdicionando(false)}
                labelBtn="✅ Adicionar"
                loading={loading}
              />
            </div>
          )}

          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:12 }}>
            {premios.map(p => (
              <div key={p.id} style={{ background:'var(--bg2)', border:`2px solid ${p.ativo==1?p.cor+'66':'var(--border)'}`, borderRadius:12, overflow:'hidden', opacity: p.ativo==1?1:0.6 }}>
                <div style={{ background: p.ativo==1?`${p.cor}22`:'var(--bg3)', padding:'12px 14px', display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:16, height:16, borderRadius:'50%', background:p.cor, flexShrink:0 }} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:800, fontSize:14 }}>{p.nome}</div>
                    <div style={{ fontSize:11, color:'var(--text2)' }}>{TIPOS.find(t => t.value===p.tipo)?.label}</div>
                  </div>
                  <span style={{ background:'var(--bg4)', border:'1px solid var(--border)', padding:'3px 8px', borderRadius:6, fontSize:12, color:'var(--orange)', fontWeight:700 }}>{p.probabilidade}%</span>
                  <label style={{ position:'relative', width:40, height:22, cursor:'pointer', flexShrink:0 }}>
                    <input type="checkbox" checked={p.ativo==1} onChange={() => toggleAtivo(p)} style={{ opacity:0, width:0, height:0 }} />
                    <span style={{ position:'absolute', inset:0, background: p.ativo==1?'var(--orange)':'var(--bg4)', border:`1px solid ${p.ativo==1?'var(--orange)':'var(--border)'}`, borderRadius:11, transition:'.2s' }}>
                      <span style={{ position:'absolute', width:16, height:16, background:'#fff', borderRadius:'50%', top:2, left: p.ativo==1?20:2, transition:'.2s' }} />
                    </span>
                  </label>
                </div>
                <div style={{ padding:'8px 14px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
                    <span style={{ fontSize:11, color:'var(--text2)', flexShrink:0 }}>Probabilidade:</span>
                    <input type="range" min="1" max="50" value={p.probabilidade} onChange={e => updatePremio(p.id,'probabilidade',e.target.value)} style={{ flex:1, accentColor:'var(--orange)' }} />
                    <span style={{ fontSize:12, fontWeight:700, color:'var(--orange)', minWidth:36, textAlign:'right' }}>{p.probabilidade}%</span>
                  </div>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={() => setEditando(editando===p.id?null:p.id)} style={{ flex:1, background:'var(--bg4)', border:'1px solid var(--border)', color:'var(--text)', padding:'7px', borderRadius:6, cursor:'pointer', fontSize:12, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>{editando===p.id?'✕ Fechar':'✏️ Editar'}</button>
                    <button onClick={() => salvarPremio(p)} style={{ flex:1, background:'rgba(46,168,46,.15)', border:'1px solid rgba(46,168,46,.3)', color:'#2ea82e', padding:'7px', borderRadius:6, cursor:'pointer', fontSize:12, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>💾 Salvar</button>
                    <button onClick={() => removerPremio(p.id)} style={{ background:'rgba(230,48,48,.1)', border:'1px solid rgba(230,48,48,.3)', color:'var(--red)', padding:'7px 10px', borderRadius:6, cursor:'pointer', fontSize:13 }}>🗑️</button>
                  </div>
                  {editando === p.id && (
                    <FormPremio
                      dados={p}
                      onChange={(f,v) => updatePremio(p.id,f,v)}
                      onSalvar={() => salvarPremio(p)}
                      onCancelar={() => setEditando(null)}
                      loading={loading}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {aba === 'cupons' && (
        <>
          <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap' }}>
            <input className="input-field" placeholder="🔍 Buscar por cliente ou código..." value={busca} onChange={e => setBusca(e.target.value)} style={{ flex:1, minWidth:200 }} />
            <button onClick={carregarCupons} style={{ background:'var(--bg4)', border:'1px solid var(--border)', color:'var(--text)', padding:'0 16px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>🔄</button>
          </div>

          <div style={{ display:'flex', gap:6, marginBottom:16 }}>
            {[['todos','Todos'],['ativo','✅ Disponíveis'],['usado','❌ Usados']].map(([key,label]) => (
              <button key={key} onClick={() => setFiltroCupom(key)} style={{
                background: filtroCupom===key?'linear-gradient(90deg,var(--red),var(--orange))':'var(--bg3)',
                border:`1px solid ${filtroCupom===key?'transparent':'var(--border)'}`,
                color: filtroCupom===key?'#fff':'var(--text2)',
                padding:'7px 14px', borderRadius:20, cursor:'pointer', fontSize:12,
                fontFamily:'Nunito,sans-serif', fontWeight:700
              }}>{label}</button>
            ))}
          </div>

          <div style={{ fontSize:12, color:'var(--text2)', marginBottom:10 }}>{cuponsFiltrados.length} cupom(ns) encontrado(s)</div>

          {loadingCupons ? <div className="spinner" /> : !cuponsFiltrados.length ? (
            <div className="empty-state"><div className="icon">🎟️</div><h3>Nenhum cupom encontrado</h3></div>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {cuponsFiltrados.map((c, i) => (
                <div key={i} style={{ background:'var(--bg2)', border:`1px solid ${c.usado?'var(--border)':'var(--orange)'}`, borderRadius:10, padding:'12px 16px', display:'flex', alignItems:'center', gap:12, opacity: c.usado?0.7:1 }}>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                      <span style={{ fontFamily:'monospace', fontSize:15, fontWeight:800, color: c.usado?'var(--text2)':'var(--orange)', letterSpacing:1 }}>{c.cupom_codigo}</span>
                      <span style={{ fontSize:10, fontWeight:800, padding:'2px 7px', borderRadius:4, background: c.usado?'rgba(230,48,48,.15)':'rgba(46,168,46,.15)', color: c.usado?'var(--red)':'#2ea82e', border: `1px solid ${c.usado?'rgba(230,48,48,.3)':'rgba(46,168,46,.3)'}` }}>
                        {c.usado ? '❌ USADO' : '✅ DISPONÍVEL'}
                      </span>
                    </div>
                    <div style={{ fontSize:12, color:'var(--text2)' }}>
                      👤 {c.cliente_nome || 'Cliente'} &nbsp;•&nbsp; 🎁 {c.premio_nome}
                    </div>
                    <div style={{ fontSize:11, color:'var(--text3)', marginTop:2 }}>
                      📅 Gerado: {new Date(c.criado_em).toLocaleDateString('pt-BR')}
                      {c.validade && ` • Válido até: ${new Date(c.validade).toLocaleDateString('pt-BR')}`}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
